import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LANGS, DEFAULT_LANG, type Lang, type Dictionary } from "./types";
import { ro } from "./locales/ro";
import { en } from "./locales/en";
import { es } from "./locales/es";
import { it } from "./locales/it";
import { pl } from "./locales/pl";
import { hu } from "./locales/hu";
import { cs } from "./locales/cs";
import { bg } from "./locales/bg";
import { pt } from "./locales/pt";

export const dictionaries: Record<Lang, Dictionary> = { ro, en, es, it, pl, hu, cs, bg, pt };

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: Object.fromEntries(
      LANGS.map((l) => [l, { translation: dictionaries[l] }])
    ),
    lng: DEFAULT_LANG,
    fallbackLng: DEFAULT_LANG,
    supportedLngs: LANGS as unknown as string[],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

export default i18n;
